import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

import { storageKeys } from 'settings';
import { APIHandler, Image, StorageHandler, Progress } from 'C4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class SubAppButton extends Component {
  constructor(props) {
    super(props);

    const { src, customName, appId } = this.props;

    let newSrc = src;
    const name = customName.length > 0 ? customName : 'Icon-180';
    if (newSrc.length === 0) newSrc = `https://front.travpromobile.com/${appId}/${name}.png`;

    this.state = {
      appId,
      src: newSrc,
      redir: '',
    };

    this.saveSubApp = this.saveSubApp.bind(this);
  }

  saveSubApp() {
    const { appId } = this.state;
    const { pageId, type } = this.props;
    APIHandler.getChapters(appId)
      .then((chapters) => {
        APIHandler.getAppInfo(appId)
          .then((appInfo) => {
            const { chapterID: chapterId } = chapters.app[0];
            const {
              appIcon, color, colorDarker, colorLighter, diplomaCheckmarkColor, diplomaColor, // styling
              facebook, flickr, googlePlus, instagram, linkedin, pinterest, shareCopy, shareTitle, twitter, youtube, // social
              clientName, programName, locationName, clientWebsite, // clientInfo
            } = appInfo.app[0];
            StorageHandler.load(storageKeys.user)
              .then((user) => {
                const { email } = user;
                const activeSubApp = {
                  global: {
                    appId,
                    chapterId,
                    pageId,
                    email,
                    type,
                  },
                  styling: {
                    appIcon,
                    color,
                    colorDarker,
                    colorLighter,
                    diplomaCheckmarkColor,
                    diplomaColor,
                  },
                  social: {
                    facebook,
                    flickr,
                    googlePlus,
                    instagram,
                    linkedin,
                    pinterest,
                    shareCopy,
                    shareTitle,
                    twitter,
                    youtube,
                  },
                  clientInfo: {
                    clientName,
                    programName,
                    locationName,
                    clientWebsite,
                  },
                };
                StorageHandler.save(storageKeys.activeSubApp, activeSubApp);
                this.setState({ redir: '/main/subApp' });
              });
          });
      });
  }

  render() {
    const { src, redir } = this.state;
    const {
      appId,
      size,
      progress: userProgress,
      name,
      type,
    } = this.props;
    const percentage = Math.round((userProgress.progress / userProgress.total_pages) * 100);
    if (appId !== '601') {
      // Lock sub app in retain if not completed in training
      return (
        <button className="subApp__Card" onClick={this.saveSubApp}>
          <div className="subApp__Card--content">
            <div className="overlay">
              <FontAwesomeIcon icon={['fas', 'lock']} />
              <div className="coming_soon">Coming Soon</div>
            </div>
            {redir.length === 0 &&
              <Image
                appId={+appId}
                default={size}
                fit="clamp"
                resize={false}
                src={src}
                stylingOverride={{ height: '12rem' }}
                staticImage
              />}
            <h4>{name}</h4>
          </div>
        </button>
      );
    }

    return (
      <button className="subApp__Card" onClick={this.saveSubApp}>
        <div className="subApp__Card--content">
          {redir.length === 0 &&
            <Image
              appId={+appId}
              default={size}
              fit="clamp"
              resize={false}
              src={src}
              stylingOverride={{ height: '12rem' }}
              staticImage
            />}
          <h4>{name}</h4>
        </div>
        {type === 'training' && <Progress id={`SubAppButton_${src}`} value={percentage} />}
        {redir.length > 0 && <Redirect to={redir} />}
      </button>
    );
  }
}

SubAppButton.propTypes = {
  appId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  customName: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
  pageId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  progress: PropTypes.shape({
    progress: PropTypes.number,
    last_page: PropTypes.number,
    total_pages: PropTypes.number,
    inserted_at: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }).isRequired,
  name: PropTypes.string,
};

SubAppButton.defaultProps = {
  appId: -1,
  customName: '',
  src: '',
  size: { height: 50, width: 50 },
  pageId: 0,
  name: 'Level II Chapter',
};
